import { useContext } from 'react';
import { HealthCenterContext } from './HealthCenterContext';

export const useHealthCenterContext = () => useContext(HealthCenterContext);
